import { routing } from "../../routing.js";
import { SortOrder } from "../../types/index.js";
export function createClient(api) {
  async function list(newsroomId, {
    sortOrder
  } = {}) {
    const url = routing.newsroomCategoriesUrl.replace(':newsroom_id', String(newsroomId));
    const {
      categories
    } = await api.get(url, {
      query: {
        sort: SortOrder.stringify(sortOrder)
      }
    });
    return categories;
  }
  async function get(newsroomId, categoryId) {
    const url = routing.newsroomCategoriesUrl.replace(':newsroom_id', String(newsroomId));
    const {
      category
    } = await api.get(`${url}/${categoryId}`);
    return category;
  }
  async function create(newsroomId, payload) {
    const url = routing.newsroomCategoriesUrl.replace(':newsroom_id', String(newsroomId));
    const {
      category
    } = await api.post(url, {
      payload
    });
    return category;
  }
  async function update(newsroomId, categoryId, payload) {
    const url = routing.newsroomCategoriesUrl.replace(':newsroom_id', String(newsroomId));
    const {
      category
    } = await api.patch(`${url}/${categoryId}`, {
      payload
    });
    return category;
  }
  async function doDelete(newsroomId, categoryId) {
    const url = routing.newsroomCategoriesUrl.replace(':newsroom_id', String(newsroomId));
    return api.delete(`${url}/${categoryId}`);
  }
  return {
    list,
    get,
    create,
    update,
    delete: doDelete
  };
}